import { getApiUrl } from '../utils/apiUrl';

const API_BASE_URL = getApiUrl();

export async function fetchPosts(token) {
  const response = await fetch(`${API_BASE_URL}/feed/posts`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!response.ok) throw new Error('Failed to fetch posts');
  return response.json();
}

export async function createPost(token, content, visibility, imageFile) {
  const formData = new FormData();
  formData.append('content', content);
  formData.append('visibility', visibility);
  if (imageFile) {
    formData.append('image', imageFile);
  }

  const response = await fetch(`${API_BASE_URL}/feed/posts`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
      // Don't set Content-Type - browser will set it with boundary for multipart/form-data
    },
    body: formData
  });
  if (!response.ok) throw new Error('Failed to create post');
  return response.json();
}

export async function deletePost(token, postId) {
  const response = await fetch(`${API_BASE_URL}/feed/posts/${postId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!response.ok) throw new Error('Failed to delete post');
  return response.json();
}

export async function toggleLike(token, postId) {
  const response = await fetch(`${API_BASE_URL}/feed/posts/${postId}/like`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!response.ok) throw new Error('Failed to toggle like');
  return response.json();
}

export async function fetchLikes(token, postId) {
  const response = await fetch(`${API_BASE_URL}/feed/posts/${postId}/likes`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!response.ok) throw new Error('Failed to fetch likes');
  return response.json();
}

export async function fetchComments(token, postId) {
  const response = await fetch(`${API_BASE_URL}/feed/posts/${postId}/comments`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!response.ok) throw new Error('Failed to fetch comments');
  return response.json();
}

export async function addComment(token, postId, content) {
  const response = await fetch(`${API_BASE_URL}/feed/posts/${postId}/comments`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ content })
  });
  if (!response.ok) throw new Error('Failed to add comment');
  return response.json();
}

export async function deleteComment(token, postId, commentId) {
  const response = await fetch(`${API_BASE_URL}/feed/posts/${postId}/comments/${commentId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!response.ok) throw new Error('Failed to delete comment');
  return response.json();
}
